import { render, staticRenderFns } from "./salesInstrumentOrderAction.vue?vue&type=template&id=1530ffc6&scoped=true"
import script from "./salesInstrumentOrderAction.vue?vue&type=script&lang=js"
export * from "./salesInstrumentOrderAction.vue?vue&type=script&lang=js"
import style0 from "./salesInstrumentOrderAction.vue?vue&type=style&index=0&id=1530ffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530ffc6",
  null
  
)

export default component.exports